(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var init=function(){
    var sections=document.querySelectorAll('main .shopify-section');
    if('IntersectionObserver' in window && sections.length){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('hoc-in');io.unobserve(e.target);}});},{threshold:.08,rootMargin:'0px 0px -40px 0px'});
      sections.forEach(function(s,i){ if(i===0) return; var r=s.getBoundingClientRect(); if(r.top>window.innerHeight*0.9){ s.classList.add('hoc-pre'); io.observe(s);} });
    }
    var seen=[];
    document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
      if(!a.querySelector('img'))return;
      var card=a.closest('product-card,.product-card,.card,li,article')||a;
      if(seen.indexOf(card)>-1)return; seen.push(card);
      card.classList.add('hoc-c3d');
      var raf=null;
      card.addEventListener('pointermove',function(ev){
        if(ev.pointerType!=='mouse')return;
        if(raf)return;
        raf=requestAnimationFrame(function(){
          raf=null;
          var b=card.getBoundingClientRect();
          var x=(ev.clientX-b.left)/b.width-.5, y=(ev.clientY-b.top)/b.height-.5;
          card.style.transform='perspective(900px) rotateY('+(x*9).toFixed(2)+'deg) rotateX('+(-y*7).toFixed(2)+'deg) translateY(-4px)';
        });
      });
      card.addEventListener('pointerleave',function(){ if(raf){cancelAnimationFrame(raf);raf=null;} card.style.transform=''; });
    });
    var h=document.querySelector('main h1'); if(h && h.textContent.trim().length<80) h.classList.add('hoc-shimmer');
    document.querySelectorAll('main button[type="submit"], main .button, main a.button').forEach(function(b){b.classList.add('hoc-btnfx');});
  };
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
